import { useRef } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { cn } from "@/lib/utils";

export const TableTooltipParagraph = ({
  className,
  text,
}: {
  className?: string;
  text: string;
}) => {
  const hoverTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <p
            className={cn("truncate", className)}
            onMouseEnter={() => {
              hoverTimerRef.current = setTimeout(() => {
                mixpanelUtils.trackHover(
                  "Truncated text tooltip",
                  getScreenFromPathname(window.location.pathname),
                );
              }, 300);
            }}
            onMouseLeave={() => {
              if (hoverTimerRef.current) {
                clearTimeout(hoverTimerRef.current);
                hoverTimerRef.current = null;
              }
            }}
          >
            {text}
          </p>
        </TooltipTrigger>
        <TooltipContent className="max-w-xl whitespace-pre-wrap">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
